import moment from 'moment';
import i18n from '../../../adapters/primary/libs/i18n';
import { MaxRetries } from 'app/adapters/secondary/gateways/upload/UploadGateway';

export function buildSibelgaErrorMessages(error) {
    const errorsMessages = [];

    if (error instanceof MaxRetries) {
        errorsMessages.push(i18n.t('common.snack.sibelga.uploadTooLong'));
    } else if (error.response?.data?.name === 'InvalidFilesNumber') {
        errorsMessages.push(i18n.t('common.snack.sibelga.invalidFilesNumber'));
    } else if (error.response?.data?.name === 'UploadInProgress') {
        errorsMessages.push(i18n.t('common.snack.sibelga.uploadInProgress'));
    } else if (error.response?.data?.name === 'UnknownFile') {
        const fileName = error.response.data.fileName;
        errorsMessages.push(
            i18n.t('common.snack.sibelga.unknownFile', { fileName })
        );
    } else if (error.response?.data?.name?.startsWith('IncompleteData')) {
        const { consumers, producers } = error.response.data.data;
        const MAX_DISPLAYED_DATES_NUMBER = 4;

        const formatDates = (dates) =>
            dates
                .slice(0, MAX_DISPLAYED_DATES_NUMBER)
                .map((d) =>
                    moment
                        .utc(d._date)
                        .add(1, 'hours')
                        .format('DD/MM/YYYY HH:mm')
                )
                .join(' , ') +
            (dates.length > MAX_DISPLAYED_DATES_NUMBER ? ' ...' : '');

        Object.entries(consumers).forEach(([ean, dates]) => {
            errorsMessages.push(
                i18n.t('common.snack.sibelga.incompleteConsumerData', {
                    ean,
                    dates: formatDates(dates),
                })
            );
        });

        Object.entries(producers).forEach(([ean, dates]) => {
            errorsMessages.push(
                i18n.t('common.snack.sibelga.incompleteProducerData', {
                    ean,
                    dates: formatDates(dates),
                })
            );
        });
    } else if (error.response?.data?.name === 'MissingColumns') {
        const { columns, fileName } = error.response.data;
        errorsMessages.push(
            i18n.t('common.snack.sibelga.missingColumns', {
                columns: columns.join(', '),
                fileName,
            })
        );
    } else if (error.response?.data?.name === 'InconsistentPerimeter') {
        const { unexpected, missing } = error.response.data.data;
        ['consumers', 'producers'].forEach((type) => {
            missing[type].forEach((ean) =>
                errorsMessages.push(
                    i18n.t(
                        `common.snack.sibelga.missing${
                            type === 'consumers' ? 'Consumer' : 'Producer'
                        }Data`,
                        { ean }
                    )
                )
            );
            unexpected[type].forEach((ean) =>
                errorsMessages.push(
                    i18n.t(
                        `common.snack.sibelga.unexpected${
                            type === 'consumers' ? 'Consumer' : 'Producer'
                        }Data`,
                        { ean }
                    )
                )
            );
        });
    } else if (error.response?.data?.name === 'InvalidPeriod') {
        const { participants } = error.response.data.data;
        participants.forEach((ean) =>
            errorsMessages.push(
                i18n.t('common.snack.sibelga.invalidDateRange', { ean })
            )
        );
    } else {
        errorsMessages.push(error.message || error.response?.message);
    }

    return errorsMessages;
}
